import router from '@/router'

type LaunchParams = {
  targetURL?: string
}

type LaunchQueue = {
  setConsumer: (callback: (params: LaunchParams) => void) => void
}

declare global {
  interface Window {
    launchQueue?: LaunchQueue
  }
}

/**
 * When the installed PWA captures an in-scope link (Teams, Slack, email, etc.),
 * `focus-existing` delivers the URL via `launchQueue` instead of a full navigation.
 */
export function registerLaunchHandler() {
  const { launchQueue } = window
  if (!launchQueue) return

  launchQueue.setConsumer((launchParams) => {
    const { targetURL } = launchParams
    if (!targetURL) return

    let path: string
    try {
      const url = new URL(targetURL, window.location.origin)
      if (url.origin !== window.location.origin) return
      path = `${url.pathname}${url.search}${url.hash}`
    } catch {
      return
    }

    if (path === router.currentRoute.value.fullPath) return

    void router.push(path).catch(() => {
      window.location.assign(path)
    })
  })
}
